import { useMemo } from "react";
import { Flex, Text } from "@radix-ui/themes";
import * as Switch from "@radix-ui/react-switch";

import { useTopicDraft } from "@/v2/features/simulator/context/useTopicDraft";
import { useSimulator } from "../../context/SimulatorWrapper";

import styles from "./styles.module.scss";

export const Knowledge = ({ topicId }: { topicId: number }) => {
  const { updateTopicReleasePolicy, currentRelease } = useSimulator();
  const { isKnowledgeEnabled, isHistoricalTicketsEnabled, isWikiEnabled } =
    useTopicDraft({
      topicId,
    });

  const releaseId = useMemo(() => currentRelease?.id, [currentRelease]);
  if (!releaseId) {
    return null;
  }

  const handleKnowledgeToggle = (value: boolean) => {
    const data = {
      topicId,
      releaseId,
      isKnowledgeEnabled: value,
    };
    updateTopicReleasePolicy(topicId, releaseId, data);
  };

  const handleWikiToggle = (value: boolean) => {
    const data = {
      topicId,
      releaseId,
      isWikiEnabled: value,
    };
    updateTopicReleasePolicy(topicId, releaseId, data);
  };

  const handleTicketsToggle = (value: boolean) => {
    const data = {
      topicId,
      releaseId,
      isHistoricalTicketsEnabled: value,
    };
    updateTopicReleasePolicy(topicId, releaseId, data);
  };

  return (
    <div className={styles.knowledgeSourcesSection}>
      <Flex direction="column" gap="1">
        <Text style={{ fontSize: "14px", fontWeight: 500 }}>
          Knowledge Sources
        </Text>
        <Flex direction="column" gap="2">
          <Text as="label" size="2">
            <Flex gap="2" align="center">
              <Switch.Root
                className={styles.switchRoot}
                checked={isKnowledgeEnabled}
                onCheckedChange={handleKnowledgeToggle}
              >
                <Switch.Thumb className={styles.switchThumb} />
              </Switch.Root>
              Review help center articles
            </Flex>
          </Text>
          <Text as="label" size="2">
            <Flex gap="2" align="center">
              <Switch.Root
                className={styles.switchRoot}
                checked={isWikiEnabled}
                onCheckedChange={handleWikiToggle}
              >
                <Switch.Thumb className={styles.switchThumb} />
              </Switch.Root>
              Review wiki articles
            </Flex>
          </Text>
          <Text as="label" size="2">
            <Flex gap="2" align="center">
              <Switch.Root
                className={styles.switchRoot}
                checked={isHistoricalTicketsEnabled}
                onCheckedChange={handleTicketsToggle}
              >
                <Switch.Thumb className={styles.switchThumb} />
              </Switch.Root>
              Review historical tickets
            </Flex>
          </Text>
        </Flex>
      </Flex>
    </div>
  );
};
